import React, { Component, ComponentType } from 'react';
import { TSelectableItemProps, TSelectableItemState } from './Selectable.types';
import { SelectableGroupContext } from './SelectableGroup.context';
import { getBoundsForNode, TComputedBounds, TGetBoundsForNodeArgs } from './utils';

type TAddedProps = Partial<Pick<TSelectableItemProps, 'isSelected'>>;

export const createSelectable = <T extends any>(
  WrappedComponent: ComponentType<TSelectableItemProps & T>
): ComponentType<T & TAddedProps> =>
  class SelectableItem extends Component<T & TAddedProps, TSelectableItemState> {

    public static contextType = SelectableGroupContext;

    public static defaultProps = {
      isSelected: false as any
    };

    public state = {
      isSelected: this.props.isSelected as any,
      isSelecting: false
    };

    public node: HTMLElement | null = null;

    public bounds: TComputedBounds[] | null = null;

    public componentDidMount() {
      this.updateBounds();
      this.context.selectable.register(this);
    }

    public componentWillUnmount() {
      this.context.selectable.unregister(this);
    }

    public updateBounds = (containerScroll?: TGetBoundsForNodeArgs) => {
      this.bounds = getBoundsForNode(this.node!, containerScroll);
    }

    public getSelectableRef = (ref: HTMLElement | null) => {
      this.node = ref;
    }

    public render() {
      return (
        <WrappedComponent {...this.props} {...this.state} selectableRef={this.getSelectableRef} />
      );
    }
  };
